<template>
  <div class="box f_color1 font2">
    <van-nav-bar 
      :title="'数据概览'" 
      left-text="" 
      left-arrow
      @click-left="onClickLeft" 
      @click-right="onClickRight"
      :style="{ background: '#FFD700', color: '#333333' }"
      :title-style="{ color: '#333333' }"
      :left-arrow-style="{ color: '#333333' }"
    >
      <template #right>
        <div class="nav-bar-right">
          <template v-if="this.groupInfo && this.groupInfo.type === 0">
            <a ref="downloadLink" :href="downloadUrl" target="downloadFile"></a>
            <van-button type="primary" class="export-button" icon="download" plain @click="downloadFile">导出
            </van-button>
            <iframe style="display: none;" name="downloadFile"></iframe>
          </template>
        </div>
      </template>
    </van-nav-bar>
    <div v-if="!!groupInfo">
    
      <van-dialog
        v-model:show="showExportLink"
        title="导出链接"
        :show-cancel-button="true"
        cancel-button-text="关闭"
        confirm-button-text="复制链接"
        @confirm="copyExportLink"
      >
        <div class="export-link-content">
          <p class="link-label" style="word-break: break-all; padding: 8px; background: #f5f5f5; border-radius: 4px; color: #333;">请复制以下链接到浏览器打开下载：</p>
          <!-- 优化链接展示样式，方便手动复制 -->
          <div class="link-text" style="word-break: break-all; padding: 8px; background: #f5f5f5; border-radius: 4px; color: #333;">
            {{ exportLink }}
          </div>
        </div>
      </van-dialog>

      <van-search class="search-bar" v-model="search" @search="onSearch" shape="round" show-action placeholder="输入用户ID">
        <template #action>
          <div class="search-btn" @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="filter-section">
        <div class="id-type-group">
          <van-radio-group v-model="checked" direction="horizontal">
            <van-radio name="0" icon-size="14px">用户ID</van-radio>
            <van-radio name="1" icon-size="14px">上级ID</van-radio>
          </van-radio-group>
        </div>
        <van-dropdown-menu v-if="this.groupInfo && this.groupInfo.type === 0" class="income-type-select" active-color="#ff9500">
          <van-dropdown-item v-model="incomeType" :options="incomeTypes" @change="onIncomeTypeChanged" />
        </van-dropdown-menu>
      </div>
      <div class="date-range-selector">
        <div class="date-btn ltime" @click="onTimeBeginTapped">{{ timeBeginDisplay }}</div>
        <span class="date-separator">至</span>
        <div class="date-btn" @click="onTimeEndTapped">{{ timeEndDisplay }}</div>
      </div>
      <van-list class="list font2" v-model:loading="loading" :immediate-check="false" :finished="finished"
                finished-text="没有更多了" @load="onLoad">
        <div v-if="list.length === 0 && !loading" class="empty-list">
          <van-icon name="document-text" size="48" color="#c0c4cc" />
          <p class="empty-text">暂无用户数据</p>
        </div>
        <div class="listItem user-card" v-for="(li, i) in list" :key="i">
          <div class="body">
            <div class="person-header">
              <div class="avatar">
                <img :src="li.avatar || '/default-avatar.png'" alt=""></div>
              <div class="left">
                <div class="name">{{ li.userInfo.nickName }}</div>
                <div class="uid" @click="onUidTapped(li)">ID: {{ li.userId }}</div>
                <div class="uid">加入时间: {{ !!li.joinTime ? getDisplayTime(li.joinTime) : '--' }}</div>
                <div class="uid">收益日期: {{ !!li.day ? li.day : '0' }}</div>
              </div>
            </div>

            <div class="data-grid">
              <div class="d-item-inline data-item highlight" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.income) }}</div>
                <div class="t-desc">总收益</div>
              </div>
              <div class="d-item-inline data-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%"
                   @click="onInviteCodeTapped(li)">
                <div class="t-time">{{ (!!li.code ? li.code : '--') }}</div>
                <div class="t-desc">邀请码</div>
              </div>
              <div class="d-item-inline data-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%"
                   @click="onParentIdTapped(li)">
                <div class="t-time">{{ (!!li.parentId ? li.parentId : '--') }}</div>
                <div class="t-desc">上级ID</div>
              </div>
            </div>
            <div class="income-details">
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.my) }}</div>
                <div class="t-desc desc">私聊收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.voice) }}</div>
                <div class="t-desc desc">音频收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 15px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.video) }}</div>
                <div class="t-desc">视频收益</div>
              </div>
            </div>
            <div class="income-details">
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.gift) }}</div>
                <div class="t-desc">礼物收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">{{ (li.heart) }}</div>
                <div class="t-desc">心动收益</div>
              </div>
              <div class="d-item-inline detail-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">{{ (!!li.itemNum ? li.itemNum : '0') }}</div>
                <div class="t-desc">邀请充值分成</div>
              </div>
            </div>
            <div class="stats-section">
              <div class="d-item-inline stats-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">
                  {{ (!!li.heartbeatNum ? li.heartbeatNum : '0') }}/{{ (!!li.heartNumRecv ? li.heartNumRecv : '0') }}
                </div>
                <div class="t-desc">心动发送/接收(次)</div>
              </div>
              <div class="d-item-inline stats-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">
                  {{ (!!li.voiceCount ? li.voiceCount : '0') }}/{{ (!!li.voiceTime ? li.voiceTime : '0') }}
                </div>
                <div class="t-desc">语音通话(次/分钟)</div>
              </div>
              <div class="d-item-inline stats-item" style="padding-left: 10px;margin-top: 10px;display: inline-block;width: 30%">
                <div class="t-time">
                  {{ (!!li.videoCount ? li.videoCount : '0') }}/{{ (!!li.videoTime ? li.videoTime : '0') }}
                </div>
                <div class="t-desc">视频通话(次/分钟)</div>
              </div>
            </div>
          </div>
          <div class="foot">
            <div class="left action-button" @click="onCopyUserIdTapped(li)">
              <span class="icon">📋</span>
              <span>复制用户ID</span>
            </div>
            <div class="right action-button" @click="onIncomeTapped(li)">
              <span class="icon">📊</span>
              <span>查看流水</span>
            </div>
          </div>
        </div>
      </van-list>
      <van-popup v-model:show="showDatePicker" position="bottom" round>
        <van-datetime-picker v-model="datePicker" type="date" title="选择日期" :min-date="minDate" :max-date="maxDate"
                             @confirm="onDatePickerConfirm" @cancel="onDatePickerCancel"/>
      </van-popup>
    </div>
    <div v-if="!!groupInfo" class="bottom">
      <div v-if="incomeList && incomeList.length === 0" class="empty-state">
        <span>暂无相关流水数据</span>
      </div>
      
      <!-- 表格数据 -->
      <div v-else class="stats-table-wrapper">
        <table class="stats-table">
          <!-- 收益流水 - type=0 -->
          <tr v-if="formatNumber(getIncomeByType(0).totalOwnerIncome)!='0'" class="stats-row">
            <td class="stats-label">
              <div class="label-title">收益流水</div>
              <div class="label-value">{{ formatNumber(getIncomeByType(0).totalIncome) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">邀请分成</div>
              <div class="cell-value">{{ formatNumber(getIncomeByType(0).totalParentIncome) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">组长分成</div>
              <div class="cell-value">{{ formatNumber(getIncomeByType(0).totalOwnerIncome) }}</div>
            </td>
          </tr>
          
          <!-- 充值流水 - type=1 -->
          <tr v-if="formatNumber(getIncomeByType(1).totalOwnerIncome)!='0'" class="stats-row">
            <td class="stats-label">
              <div class="label-title">充值流水</div>
              <div class="label-value">{{ formatNumber(getIncomeByType(1).totalIncome) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">邀请分成</div>
              <div class="cell-value">{{ formatNumber(getIncomeByType(1).totalParentIncome) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">组长分成</div>
              <div class="cell-value">{{ formatNumber(getIncomeByType(1).totalOwnerIncome) }}</div>
            </td>
          </tr>
          
          <!-- 会员流水 - type=2 -->
          <tr v-if="formatNumber(getIncomeByType(2).totalOwnerIncome)!='0'" class="stats-row">
            <td class="stats-label">
              <div class="label-title">会员流水</div>
              <div class="label-value">{{ formatNumber(getIncomeByType(2).totalIncome) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">邀请分成</div>
              <div class="cell-value">{{ formatNumber(getIncomeByType(2).totalParentIncome) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">组长分成</div>
              <div class="cell-value">{{ formatNumber(getIncomeByType(2).totalOwnerIncome) }}</div>
            </td>
          </tr>

          <tr class="stats-row total-row">
            <td class="stats-label">
              <div class="label-title">总流水</div>
              <div class="label-value highlight">{{ formatNumber(calculateGrandTotal()) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">邀请分成合计</div>
              <div class="cell-value highlight">{{ formatNumber(calculateTotalParentIncome()) }}</div>
            </td>
            <td class="stats-cell">
              <div class="cell-label">组长分成合计</div>
              <div class="cell-value highlight">{{ formatNumber(calculateTotalOwnerIncome()) }}</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <Mask v-if="marke"></Mask>
  </div>
</template>

<script>
import Mask from '../components/Mask'
import routerUtil from '../utils/routerUtil'
import {Toast} from "vant"
import moment from 'moment'
import copy from "copy-to-clipboard";

export default {
  name: 'Income',
  data() {
    return {
      isApp: localStorage.getItem("isApp"),
      show: true,
      showExportLink: false,
      exportLink: '',
      search: '',
      downloadUrl: '',
      checked: '0',
      incomeType: 0,
      incomeTypes: [
        {text: '全部类型', value: 0},
        {text: '私聊送礼', value: 22},
        {text: '心动送礼', value: 63},
        {text: '普通聊天', value: 52},
        {text: '微信收益', value: 71},
        {text: '语音收益', value: 37},
        {text: '视频收益', value: 55},
        {text: '邀请充值分成', value: 66},
        {text: '邀请消费返现', value: 99},
        { text: '邀请开通会员分成', value: 74 },
      ],
      timeBegin: 0,
      timeEnd: 0,
      showDatePicker: false,
      datePickerMode: 0,
      datePicker: null,
      minDate: null,
      maxDate: null,
      groupInfo: null,
      searchUid: null,
      searchType: 0,
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      incomeList:[],
      totalIncome: 0,
      totalUserChatIncome: 0,
      userInviteRewards: 0,
      totalParentIncome: 0,
      groupChatRewards: 0,
      groupInviteRewards: 0,
      marke: false,
      isDownloaded: false,
      params: "",
      datePickerDisabledDate: null // 日期禁用函数
    }
  },
  components: {
    Mask,
  },
  computed: {
    timeBeginDisplay() {
      const date = new Date(this.timeBegin);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
    },
    timeEndDisplay() {
      const date = new Date(this.timeEnd);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
    }
  },
  mounted() {
    if (this.$route.params.userId) {
      this.search = this.$route.params.userId
      this.searchUid = parseInt(this.search);
    }
    this.reqInfo()
  },
  methods: {
    /**
     * 根据类型获取对应的收益数据
     * @param {Number} type 流水类型：0收益流水 1充值流水 2会员流水
     * @returns {Object} 对应类型的收益数据对象
     */
    getIncomeByType(type) {
      if (typeof type !== 'number' || type < 0 || type > 2) {
        console.warn(`无效的流水类型: ${type}`);
        return {};
      }
      return this.incomeList.find(item => item.type === type) || {};
    },

    formatNumber(num) {
      if (num === undefined || num === null) {
        return '0';
      }
      const number = Number(num);
      if (isNaN(number)) {
        return '0';
      }
      return number.toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },

    /**
     * 计算全部总收益
     * @returns {Number} 所有流水类型的总收益合计
     */
    calculateGrandTotal() {
      return this.incomeList.reduce((sum, item) => {
        const value = Number(item.totalIncome) || 0;
        if(item.totalOwnerIncome==0) return sum;
        return sum + value;
      }, 0);
    },

    /**
     * 计算邀请分成总和
     * @returns {Number} 所有类型的邀请分成总和
     */
    calculateTotalParentIncome() {
      return this.incomeList.reduce((sum, item) => {
        const value = Number(item.totalParentIncome) || 0;
        if(item.totalOwnerIncome==0) return sum;
        return sum + value;
      }, 0);
    },
    
    /**
     * 计算组长分成总和
     * @returns {Number} 所有类型的组长分成总和
     */
    calculateTotalOwnerIncome() {
      return this.incomeList.reduce((sum, item) => {
        const value = Number(item.totalOwnerIncome) || 0;
        if(item.totalOwnerIncome==0) return sum;
        return sum + value;
      }, 0);
    },

    prepareDownload() {
      const requestData = {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd
      };

      this.params = new URLSearchParams(requestData).toString();
      const downloadUrl = 'http://localhost:8088/api/user/pay_group/gincomelistout/x.xls?' + this.params;
      this.downloadUrl = downloadUrl;
      this.$refs.downloadLink.click();
    },

    prepareDownload1() {
      const requestData = {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd
      };

      this.params = new URLSearchParams(requestData).toString();
      const downloadUrl = 'http://localhost:8088/api/user/pay_group/gincomelistout/x.xls?' + this.params;
      this.downloadUrl = downloadUrl;
    },

    onUidTapped(li) {
      copy(li.userId);
      Toast('用户ID已复制');
    },

    onInviteCodeTapped(li) {
      copy(li.code);
      Toast('邀请码已复制');
    },

    onParentIdTapped(li) {
      if (!li.parentId) return
      copy(li.parentId);
      Toast('上级ID已复制');
    },

    onCopyUserIdTapped(li) {
      this.onUidTapped(li)
    },

    onIncomeTapped(li) {
      this.$router.push({
        name: 'Income',
        params: {
          userId: li.userId
        }
      });
    },

    /**
     * 下载文件核心方法
     * App环境：拼接同源链接 → 弹窗复制
     * Web环境：POST请求 → Blob下载
     */
    downloadFile() {
      // 统一构造请求参数
      const requestParams = {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd
      };

      // App环境：生成同源下载链接，弹窗复制
   if (this.isApp) {
  // 自动获取当前 host
  const protocol = window.location.protocol;
  const host = window.location.host;
  const currentHost = protocol + '//' + host;

  const queryString = new URLSearchParams(requestParams).toString();
  const baseUrl = currentHost + '/api/user/pay_group/gincomelistout';
  
  this.exportLink = baseUrl + '?' + queryString;
  this.showExportLink = true;
  return;
}

      // Web环境：POST请求下载文件
      this.$request.postJson( '/api/user/pay_group/gincomelistout', requestParams)
        .then(buffer => {
          const encoder = new TextEncoder();
          const xmlData = encoder.encode(buffer.data);
          const blob = new Blob([xmlData], {type: 'application/octet-stream'});
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          let now = new Date();
          let month = now.getMonth() + 1;
          let t = '' + month + now.getDate() + now.getHours();
          let name = '成员收益流水概览' + t + '.xls';
          link.setAttribute('download', name);
          document.body.appendChild(link);
          link.click();
          // 释放URL对象，避免内存泄漏
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        });
    },

    /**
     * 复制导出链接
     */
    copyExportLink() {
      if (!this.exportLink) {
        Toast('链接生成失败，请重试');
        return;
      }
      
      if (navigator.clipboard) {
      copy(this.exportLink)
            Toast('下载链接已复制到剪贴板');
            this.showExportLink = false;
        
      } else {
        // 兼容旧浏览器
        const textArea = document.createElement('textarea');
        textArea.value = this.exportLink;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        Toast('下载链接已复制到剪贴板');
        this.showExportLink = false;
      }
    },

    reqInfo() {
      this.$request.postJson('/api/user/pay_group/info', {})
        .then((res) => {
          if (res.data.code == 0) {
            this.groupInfo = res.data.data;
            if (!this.groupInfo) {
              Toast('暂无推广组信息');
              routerUtil.back()
              return;
            }
            this.prepareDownload1()
            switch (this.groupInfo.period) {
              case 1:
                this.timeBegin = moment().startOf('day').valueOf();
                this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                break;
              case 2:
                this.timeBegin = moment().startOf('day').valueOf();
                this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                break;
              case 3:
                this.timeBegin = moment().startOf('day').valueOf();
                this.timeEnd = moment().endOf('day').add(1, 'days').valueOf();
                break;
            }
            this.getList()
            this.getStatistics()
          }
        })
    },

    getList(type) {
      let lastId = ''
      if (type && this.list.length > 0) {
        lastId = this.list[this.list.length - 1].id
      }
      this.$request.postJson( '/api/user/pay_group/gincomelist', {
        groupId: this.groupInfo.id,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
        startTime: this.timeBegin,
        endTime: this.timeEnd,
        lastId: lastId,
        pageSize: 15
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.length == 0) {
            this.loading = false;
            this.refreshing = false
            this.finished = true;
            return
          }
          const uids = [];
          for (let log of res.data.data) {
            uids.push(log.userId);
          }
          this.$request.post('/api/user/info/userInfoByGroup', {userIds: JSON.stringify(uids)})
            .then((res1) => {
              this.loading = false;
              this.refreshing = false
              if (res1.data.code == 0) {
                const userMap = new Map();
                for (let user of res1.data.data.users) {
                  if (user.code == 0) {
                    userMap.set(user.userId, user);
                  } else {
                    Toast("请求用户基本信息失败")
                    return;
                  }
                }
                for (let log of res.data.data) {
                  log.userInfo = userMap.get(log.userId);
                }
                this.list.push(...res.data.data)
                this.finished = res.data.data.length < 15
              }
            })
        }
      })
    },

    getStatistics() {
      this.$request.postJson( '/api/user/pay_group/getIncomeTotalList', {
        groupId: this.groupInfo.id,
        startTime: this.timeBegin,
        endTime: this.timeEnd,
        ownerId: this.groupInfo.ownerId,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        transType: this.incomeType,
      }).then((res) => {
        if (res.data.code == 0) {
          this.incomeList = res.data.data;
          this.incomeList.forEach(item => { 
            if(item.type==1&& item.totalOwnerIncome==0) {
              this.incomeTypes.forEach((item,index)=>{
                if(item.value==66) {
                  this.incomeTypes.splice(index, 1);
                }
              })
            }
            if(item.type==2&& item.totalOwnerIncome==0) {
              this.incomeTypes.forEach((item,index)=>{
                if(item.value==74) {
                  this.incomeTypes.splice(index, 1);
                }
              })
            }
          });
        }
      })
    },

    onClickLeft() {
      routerUtil.back()
    },

    onClickRight() {
    },

    onSearch() {
      if (this.search == "") {
        this.searchUid = null
      } else {
        if (isNaN(Number(this.search, 10))) {
          Toast("请输入用户ID")
          return
        }
        const uid = parseInt(this.search);
        this.searchUid = uid;
      }
      this.searchType = parseInt(this.checked)
      this.list = [];
      this.onRefresh()
      this.getStatistics()
    },

    onIncomeTypeChanged() {
      this.list = [];
      this.onRefresh()
      this.getStatistics()
    },

    onTimeBeginTapped() {
      this.datePickerMode = 1;
      this.datePicker = new Date(this.timeBegin || Date.now());
      
      // 开始时间最早为「当前时间-1个月」，最晚为当前时间
      const oneMonthAgo = moment().subtract(1, 'month').toDate();
      this.minDate = oneMonthAgo;
      this.maxDate = new Date();
      
      // 禁用超出范围的日期
      this.datePickerDisabledDate = (date) => {
        return date < this.minDate || date > this.maxDate;
      };
      
      this.showDatePicker = true;
    },

    onTimeEndTapped() {
      if (!this.timeBegin) {
        alert('请先选择开始时间');
        return;
      }
      
      this.datePickerMode = 2;
      this.datePicker = new Date(this.timeEnd || this.timeBegin);
      
      // 结束时间最大可选值：开始时间+1个月 或 当天（取较小值）
      const oneMonthLater = moment(this.timeBegin).add(1, 'month').toDate();
      const today = new Date();
      
      this.minDate = new Date(this.timeBegin);
      this.maxDate = oneMonthLater > today ? today : oneMonthLater;
      
      // 禁用超出范围的日期
      this.datePickerDisabledDate = (date) => {
        return date < this.minDate || date > this.maxDate;
      };
      
      this.showDatePicker = true;
    },

    onDatePickerConfirm(value) {
      switch (this.datePickerMode) {
        case 1:
          this.timeBegin = moment(value).startOf('day').valueOf();
          // 确保结束时间不早于开始时间
          if (!this.timeEnd || this.timeEnd < this.timeBegin) {
            this.timeEnd = moment(this.timeBegin).endOf('day').valueOf();
          }
          break;
          
        case 2: {
          this.timeEnd = moment(value).endOf('day').valueOf();
          // 确保结束时间不早于开始时间
          if (this.timeEnd < this.timeBegin) {
            this.timeEnd = moment(this.timeBegin).endOf('day').valueOf();
          }
          // 确保结束时间不超过开始时间+1个月
          const maxEndTime = moment(this.timeBegin).add(1, 'month').endOf('day').valueOf();
          if (this.timeEnd > maxEndTime) {
            this.timeEnd = maxEndTime;
          }
          break;
        }
      }
      
      this.showDatePicker = false;
      this.datePickerMode = 0;
      this.list = [];
      this.onRefresh();
      this.getStatistics();
    },

    onDatePickerCancel() {
      this.datePickerMode = 0;
      this.showDatePicker = false;
    },

    onLoad() {
      this.getList(true)
    },

    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.getList()
    },

    getDisplayTime(time) {
      const date = new Date(time);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const min = date.getMinutes();
      const sec = date.getSeconds();
      return `${date.getFullYear()}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
    }
  },
}
</script>

<style scoped lang="less">
// 全局样式
.box {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  font-size: 14px;
  color: #333333;
  padding-bottom: 200px;
}

// 导出按钮
.export-button {
  color: #333333 !important;
  border-color: #666666 !important;
  height: 30px;
  padding: 0 12px;
  font-size: 12px;
  border-radius: 15px;
  margin-right: 8px;
  background-color: transparent !important; // 确保背景透明
}

.export-button.van-button--plain {
  color: #333333 !important;
  border-color: #666666 !important;
}

.export-button.van-button--plain:active {
  background-color: rgba(102, 102, 102, 0.2) !important;
}

/* 搜索栏样式 */
.search-bar {
  margin-bottom: 16px;
  background: transparent;
  
  :deep(.van-search__content) {
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
  }
  
  :deep(.van-search__content:focus-within) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  :deep(.van-field__input) {
    color: #333333;
    background: #f5f5f5;
  }
}

.search-btn {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
}

/* 筛选区域样式 */
.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 4px;
}

.id-type-group {
  
  :deep(.van-radio__label) {
    font-size: 14px;
    color: #999999;
  }
  
  :deep(.van-radio__icon) {
    border-color: #999999;
  }
  
  :deep(.van-radio__icon--checked) {
    color: #333333;
  }
  
  :deep(.van-radio__icon--checked .van-icon) {
    background-color: #FFD700;
    border-color: #FFD700;
  }
}

.income-type-select {
  width: 120px;
  
  :deep(.van-dropdown-menu__bar) {
    box-shadow: none;
    height: 32px;
    background-color: #f5f5f5;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    
    .van-dropdown-menu__title {
      font-size: 14px;
      color: #333333;
    }
    
    .van-dropdown-menu__arrow {
      color: #888888;
    }
  }
  
  :deep(.van-dropdown-menu__content) {
    background-color: #ffffff !important;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  :deep(.van-dropdown-item) {
    background-color: #ffffff;
  }
  
  :deep(.van-dropdown-item__option) {
    color: #333333;
    background-color: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  :deep(.van-dropdown-item__option--active) {
    color: #333333;
    background-color: #FFD700;
  }
  
  :deep(.van-dropdown-item__option:active) {
    background-color: #f0f0f0;
  }
}

/* 日期选择器样式 */
.date-range-selector {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.date-btn {
  padding: 6px 12px;
  background-color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  
  &:hover {
    background-color: #fff9e6;
  }
}

.date-separator {
  color: #888888;
  font-size: 14px;
}

// 空列表状态
.empty-list {
  text-align: center;
  padding: 40px 0;
  
  .empty-text {
    margin-top: 12px;
    color: #666666;
    font-size: 14px;
  }
  
  :deep(.van-icon) {
    color: #cccccc !important;
  }
}

// 用户卡片
.user-card {
  border-radius: 12px;
  margin: 0 16px 16px 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-color: #cccccc;
  }
  
  .body {
    padding: 16px;
  }
}

// 用户头像
.avatar {
  width: 50px;
  height: 50px;
  display: inline-block;
  
  img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 2px solid #e8f5e9;
  }
}

// 个人信息
.person-header {
  margin-left: 0;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.person-header .left {
  padding-left: 12px;
  
  .name {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 4px;
  }
  
  .uid {
    font-size: 12px;
    color: #333333;
    margin-bottom: 2px;
    
    &:not(:last-child) {
      color: #333333;
      cursor: pointer;
      background-color: #ffffff;
      padding: 2px 8px;
      border-radius: 12px;
      display: inline-block;
      margin-right: 4px;
      border: 1px solid #e0e0e0;
      
      &:hover {
        color: #333333;
        background-color: #fff9e6;
      }
    }
  }
}

// 数据网格样式
.data-grid,
.income-details,
.stats-section {
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.data-item {
  background: #ffffff;
  padding: 8px 0;
  
  .t-time {
    color: #333333;
    font-weight: 500;
  }
  
  .t-desc {
    color: #333333;
    font-size: 12px;
  }
}

.data-item.highlight {
  background: #ffffff;
}

.detail-item {
  border-radius: 6px;
  background: #ffffff;
  padding: 8px 0;
  border: 1px solid #e0e0e0;
  
  .t-time {
    color: #333333;
    font-weight: 500;
  }
  
  .t-desc {
    color: #333333;
    font-size: 12px;
  }
}

.stats-item {
  background: #ffffff;
  border-radius: 6px;
  padding: 8px 0;
  border: 1px solid #e0e0e0;
  
  .t-time {
    font-size: 12px;
    color: #333333;
  }
  
  .t-desc {
    font-size: 10px;
    line-height: 1.2;
    color: #888888;
  }
}

/* 操作按钮 */
.action-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.left {
    background-color: #e0e0e0;
    color: #333333;
    border: 1px solid #cccccc;
    
    &:hover {
      background-color: #cccccc;
      transform: translateY(-1px);
    }
  }
  
  &.right {
    background-color: #cccccc;
    color: #333333;
    border: 1px solid #999999;
    
    &:hover {
      background-color: #999999;
      transform: translateY(-1px);
    }
  }
}

.icon {
  font-size: 16px;
}

// 底部统计区域
.bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: linear-gradient(to top, #f5f5f5, #ffffff);
  
  border-radius: 20px 20px 0 0;
  padding: 16px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
}

.empty-state {
  text-align: center;
  padding: 20px 0;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
}

// 统计卡片
.stats-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat-card {
  background: #f1f8e9;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e8f5e9;
  
  &.total-card {
    background: #e8f5e9;
    border-left: 3px solid #FFD700;
  }
}

.stat-header {
  margin-bottom: 8px;
}

.stat-header h4 {
  font-size: 14px;
  font-weight: 500;
  color: #FFD700;
  margin: 0 0 4px 0;
}

.stat-amount {
  font-size: 16px;
  font-weight: bold;
  color: #FFD700;
  
  &.total {
    font-size: 18px;
    color: #388e3c;
  }
}

// 自定义搜索框样式（100%可控，无任何Vant变量干扰）
.custom-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  width: 100%;
  
  // 输入框容器（模拟round形状）
  .search-input-wrap {
    flex: 1;
    background: #e0e0e0;
    border-radius: 20px; // 对应原来的shape="round"
    padding: 8px 16px;
    box-sizing: border-box;
  }
  
  // 输入框
  .search-input {
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    color: #333333; // 输入文字颜色
    font-size: 14px;
    
    // 占位符样式（全浏览器兼容）
    &::placeholder {
      color: #909090;
      font-size: 14px;
    }
    &::-webkit-input-placeholder {
      color: #909090;
    }
    &:-moz-placeholder {
      color: #909090;
    }
  }
  
  // 搜索按钮
  .search-action-btn {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    cursor: pointer;
    white-space: nowrap;
  }
}

.stat-details {
  display: flex;
  justify-content: space-between;
}

.stat-details .detail-item {
  background: transparent;
  padding: 0;
  flex: 1;
  
  .label {
    font-size: 12px;
    color: #81c784;
    display: block;
    margin-bottom: 2px;
  }
  
  .value {
    font-size: 14px;
    font-weight: 500;
    color: #4caf50;
  }
}

// 导航栏样式
:deep(.van-nav-bar) {
  background: #FFD700 !important;
  color: #333333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  &__title {
    color: #333333;
    font-weight: 500;
  }
  
  &__left {
    color: #333333;
    
    .van-icon {
      color: #fff !important;
    }
  }
}

// 列表样式覆盖
:deep(.van-list) {
  padding: 0;
  
  &__loading,
  &__finished-text {
    color: #81c784;
    font-size: 13px;
    padding: 16px 0;
  }
}

// 下拉菜单样式
:deep(.van-dropdown-menu) {
  :deep(.van-dropdown-menu__content) {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    background-color: #f5f5f5 !important;
    border: 1px solid #e0e0e0;
  }
  
  :deep(.van-dropdown-item) {
    font-size: 14px;
    color: #333333;
    background-color: #f5f5f5;
    
    &.van-dropdown-item--active {
      color: #333333;
      font-weight: 500;
    }
  }
  
  :deep(.van-dropdown-item__option) {
    color: #333333;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  :deep(.van-dropdown-item__option--active) {
    color: #333333;
    background-color: #999999;
  }
  
  :deep(.van-dropdown-item__option:active) {
    background-color: #cccccc;
  }
}

// 弹窗样式
:deep(.van-popup) {
  :deep(.van-popup__close-icon) {
    color: #909399;
  }
}

:deep(.van-datetime-picker) {
  background-color: #333333 !important;
  
  :deep(.van-picker__toolbar) {
    background: #ffffff;
    
    .van-picker__title {
      font-weight: 500;
      color: #333333;
    }
    
    .van-picker__cancel {
      color: #333333;
    }
  }
  
  :deep(.van-picker__confirm) {
    color: #333333;
  }
  
  :deep(.van-picker__columns) {
    background: #ffffff;
  }
  
  :deep(.van-picker-column) {
    background: #ffffff;
  }
  
  :deep(.van-picker-column__item) {
    color: #333333 !important;
  }
  
  :deep(.van-picker-column__item--selected) {
    color: #333333 !important;
  }
  
  :deep(.van-picker__mask) {
    background: linear-gradient(to bottom, rgba(26, 26, 26, 0.95), rgba(26, 26, 26, 0.95));
  }
}

:deep(.van-popup) {
  background-color: #333333 !important;
  
  :deep(.van-popup__close-icon) {
    color: #909399;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .box {
    padding-bottom: 220px;
  }
  
  .search-section {
    margin: 12px;
    padding: 14px;
  }
  
  .user-card {
    margin: 0 12px 12px 12px;
    
    .body {
      padding: 14px;
    }
  }
  
  .bottom {
    padding: 14px;
  }
  
  .stat-card {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .person-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .avatar {
    margin-bottom: 8px;
  }
  
  .stat-details {
    flex-direction: column;
    gap: 8px;
  }
}

// 原有样式调整
.t-desc {
  color: #888888;
}

.list {
  position: relative;
  width: 100%;
  background-color: transparent;
}

.list .listItem {
  margin-top: 0;
}

.foot {
  position: relative;
  width: 100%;
  height: 48px;
  font-size: 14px;
  line-height: 48px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 12px;
  padding-top: 12px;
  
  .left,
  .right {
    flex: 1;
    text-align: center;
  }
}

.van-pull-refresh {
  height: 100% !important;
  overflow: auto !important;
}

.van-list {
  height: auto !important;
}

// 统计表格样式
.stats-table-wrapper {
  background-color: #999999;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.stats-table {
  width: 100%;
  border-collapse: collapse;
}

.stats-row {
  border-bottom: 1px solid #cccccc;
  
  &:last-child {
    border-bottom: none;
  }
}

.stats-row.total-row {
  background-color: #f5f5f5;
}

.stats-label {
  padding: 12px 16px;
  border-left: 4px solid #666666;
  
  .label-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 4px;
  }
  
  .label-value {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    
    &.highlight {
      color: #999999;
    }
  }
}

.stats-cell {
  padding: 12px 16px;
  
  .cell-label {
    font-size: 13px;
    color: #888888;
    margin-bottom: 4px;
  }
  
  .cell-value {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    
    &.highlight {
      color: #999999;
      font-weight: 600;
    }
  }
}
</style>